import React from "react";
export const SelectUpload = () => {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.493 4.54858C13.9847 2.02884 11.7198 0.137207 8.99902 0.137207C6.83881 0.137207 4.96265 1.335 4.0283 3.08786C1.77839 3.32157 0.0292969 5.18399 0.0292969 7.4408C0.0292969 9.85829 2.04001 11.823 4.51416 11.823H14.2314C16.2944 11.823 17.9688 10.187 17.9688 8.17116C17.9688 6.24301 16.4364 4.68004 14.493 4.54858ZM10.494 6.71044V9.63188H7.50407V6.71044H5.26164L8.73741 3.31427C8.8869 3.1682 9.11862 3.1682 9.26812 3.31427L12.7364 6.71044H10.494Z"
        fill="url(#paint0_linear_1188_38753)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1188_38753"
          x1="0.029297"
          y1="5.98007"
          x2="17.9688"
          y2="5.98007"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCB57" />
          <stop offset="1" stopColor="#FF7443" />
        </linearGradient>
      </defs>
    </svg>
  );
};
